import AcknowledgementItem from '@components/common/AcknowledgementItem'
import { Content } from '@prismicio/client'
import { SliceComponentProps } from '@prismicio/react'

/**
 * Props for `AcknowledgementsV3`.
 */
export type AcknowledgementsV3Props =
  SliceComponentProps<Content.AcknowledgementsV3Slice>

/**
 * Component for "AcknowledgementsV3" Slices.
 */
const AcknowledgementsV3 = ({
  slice,
}: AcknowledgementsV3Props): JSX.Element => {
  const {
    primary: { acknowledgementItems },
  } = slice

  return (
    <section
      className="my-10"
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="space-y-1">
        {acknowledgementItems.map((item, index) => (
          <AcknowledgementItem
            key={index}
            title={item.title || ''}
            value={item.value || ''}
          />
        ))}
      </div>
    </section>
  )
}

export default AcknowledgementsV3
